import { InlineContentTypes } from '../templates/Publication/SharedPublication.routing'
import { metrics } from '../__styling'

export interface inlineArticleAdsProps {
    insertAfter: number
    noticePosition: 'above-center' | 'below-center' | 'none'
    hiddenUntilLoaded: boolean
    mastHead: 'sevennews' | 'thewest' | 'perthnow'
    slotID: string
    size: 'alwaysMrec' | 'below768Mrec' //theres so many sizes, may need to add to this as the helper function is used.
    pageType: 'article'
}

export function inlineArticleAds(
    props: inlineArticleAdsProps,
): InlineContentTypes {
    const paddingOptions: Record<
        inlineArticleAdsProps['mastHead'],
        [number, number, number, number]
    > = {
        thewest: [0, 0, metrics.thewest.margins.md, 0],
        sevennews: [0, 0, metrics.sevennews.margins.md, 0],
        perthnow: [18, 0, 18, 0],
    }

    return {
        kind: 'ad',
        insertAfter: props.insertAfter,
        content: [
            {
                noticePosition: props.noticePosition,
                hiddenUntilLoaded: props.hiddenUntilLoaded,
                padding: paddingOptions[props.mastHead],
                slot: {
                    id: props.slotID,
                    size: props.size,
                    pageType: props.pageType,
                },
            },
        ],
    }
}
